<template>
  <WeContainer header="ture" bread-crumb="" v-bind:actions="actions">
    <WeTable
      v-bind:index="false"
      v-bind:data="emailTemplate.list"
      v-bind:allowSortIndex="false"
      v-bind:columns="columns"
      v-bind:actions="tableActions"
      v-bind:ajax="true"
      v-bind:fetch-on-mount="true"
      v-bind:loading="loading"
      v-bind:table-result="tableResult"
      v-on:on-action="onAction"
      v-on:make-request="updateTemplateList"
      v-bind:componentName="componentName"
      ref="emailTemplateTable"
    ></WeTable>
  </WeContainer>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "List",
  data() {
    return {
      componentName: "emailTemplates",
      loading: false,
      actions: [
        {
          text: "Yeni Şablon",
          path: "email-templates/new",
        },
        {
          text: "Çöp Kutusu",
          class: "btn btn-outline-danger float-right",
          icon: "fas fa-trash",
          path: "email-templates/trash",
        },
      ],
      tableActions: [
        {
          icon: "fas fa-edit",
          class: "btn-outline-primary",
          action: "edit",
        },
        {
          icon: "fas fa-trash",
          class: "btn-outline-danger ml-2",
          action: "remove",
        },
      ],
      columns: [{ name: "title", th: "Şablon Adı", type: "string" }],
      tableResult: {
        item_count: 1,
        current_page: 1,
        total_page: 1,
        total_items: 1,
      },
    };
  },
  methods: {
    ...mapActions("emailTemplate", ["getList", "delete"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onDelete(data.row, data.index);
      } else if (data.key == "edit") {
        this.onEdit(data.row);
      }
    },
    checkFilterStorage() {
      return helper.checkFilterStorage(this.componentName);
    },
    onEdit(row) {
      this.$router.replace("email-templates/detail/" + row.id);
    },
    onDelete(row) {
      let message = `${row.title} isimli Şablonu silmek istediğinize emin misiniz ?`;

      this.$swal({
        title: message,
        html: `Bu işlemi <b class="text-danger">Çöp Kutusu</b> bölümünden geri alabilirsiniz.`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          this.delete({
            id: row.id,
            onSuccess: (result) => {
              if (result && result.data && result.data.status !== "error") {
                this.$toast.success("Şablon Başarıyla Silindi");
              } else {
                this.$swal({
                  title: "Şablon Silinemedi",
                  text: result.data.message,
                  icon: "error",
                  confirmButtonText: "Tamam",
                });
              }
            },
          });
        }
      });
    },
    onSearch() {
      this.$refs.emailTemplateTable.currentPage = 1;
      this.updateTemplateList();
    },
    updateTemplateList(requestData = null) {
      requestData = requestData || {
        page: 1,
        limit: 25,
      };

      this.loading = true;
      this.getList({
        table: requestData,
        onSuccess: (result) => {
          helper.copy(result, this.tableResult, ["items", "status"]);
        },
        onFinish: () => {
          this.loading = false;
        },
      });
    },
    checkPermission(code) {
      return permission.check("emailTemplate", code);
    },
  },
  computed: {
    ...mapState({
      emailTemplate: (state) => state.emailTemplate,
    }),
  },
};
</script>

